import axiosInstance from "./axiosInstance";
import { getAuthHeader } from "./departmentService";

export interface DesignationApi {
  id: number;
  publicId: string;
  designationCode: string;
  designationName: string;
  status: boolean;
}

export interface DesignationListResponse {
  items: DesignationApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

// ✅ GET
export const getDesignations = async (params: {
  searchText?: string | null;
  pageNo: number;
  pageSize: number;
}): Promise<DesignationListResponse> => {
  const res = await axiosInstance.get("/designation-master/list", {
    headers: getAuthHeader(),
    params,
  });

  return res.data;
};

// ✅ CREATE (POST)
export const createDesignation = async (payload: {
  designationCode: string;
  designationName: string;
  status: boolean;
  createdBy: string;
}) => {
  const res = await axiosInstance.post("/designation-master", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

// ✅ UPDATE (PUT)
export const updateDesignation = async (payload: {
  publicId: string;
  designationCode: string;
  designationName: string;
  status: boolean;
  updatedBy: string;
}) => {
  const res = await axiosInstance.put("/designation-master", payload, {
    headers: getAuthHeader(),
  });
  return res.data;
};

// ✅ DELETE
export const deleteDesignation = async (
  publicId: string,
  deletedBy: string
) => {
  const res = await axiosInstance.delete(
    `/designation-master/${publicId}?deletedBy=${deletedBy}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};